import styled from 'styled-components';
import { Colors } from 'core/CssVariables';

export const SBarSection = styled.div`
  margin-bottom: 8px;
`;

export const SLabelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const SLabelLeft = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.secondaryColor};
`;

export const SDurationText = styled.span`
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  text-transform: none;
  padding: 2px 10px;
  border-radius: 20px;
  color: ${Colors.SecondaryColor};
  background: ${Colors.LightPurple};
`;

export const SBarWrap = styled.div`
  position: relative;
  height: 52px;
  border-radius: 12px;
  cursor: crosshair;
  overflow: visible;
  user-select: none;
  touch-action: none;
  background: ${({ theme }) => theme.input.backgroundColor};
  border: 1px solid ${({ theme }) => theme.input.borderColor};
`;

export const STicks = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  border-radius: 12px;
  overflow: hidden;
`;

export const STick = styled.div<{ leftPct: number }>`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  left: ${({ leftPct }) => leftPct}%;
  background: ${({ theme }) => theme.input.borderColor};
  pointer-events: none;
`;

export const SRange = styled.div<{ leftPct: number; widthPct: number }>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${({ leftPct }) => leftPct}%;
  width: ${({ widthPct }) => widthPct}%;
  min-width: 4px;
  border-radius: 10px;
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    90deg,
    ${Colors.SecondaryColor},
    ${Colors.PrimaryColor}
  );
  &:active {
    cursor: grabbing;
  }
`;

export const SRangeLabel = styled.span`
  font-size: 11px;
  font-weight: 500;
  color: ${Colors.WhiteOpacity};
  white-space: nowrap;
  pointer-events: none;
  overflow: hidden;
`;

export const SHandle = styled.div<{ leftPct: number }>`
  position: absolute;
  top: 50%;
  left: ${({ leftPct }) => leftPct}%;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 32px;
  border-radius: 6px;
  cursor: ew-resize;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${Colors.White};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  &::before {
    content: '';
    width: 2px;
    height: 14px;
    border-radius: 2px;
    background: ${Colors.LightGrey};
    box-shadow: 3px 0 0 ${Colors.LightGrey};
  }
  &:hover {
    box-shadow: 0 2px 12px rgba(1, 87, 155, 0.5);
  }
`;

export const SHandleTip = styled.div`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 11px;
  white-space: nowrap;
  pointer-events: none;
  color: ${Colors.White};
  background: ${Colors.Dark};
  border: 1px solid ${({ theme }) => theme.input.borderColor};
`;

export const STickLabels = styled.div`
  position: relative;
  height: 18px;
  margin-top: 4px;
`;

export const STickLabel = styled.div<{ leftPct: number }>`
  position: absolute;
  left: ${({ leftPct }) => leftPct}%;
  transform: translateX(-50%);
  font-size: 10px;
  color: ${({ theme }) => theme.secondaryColor};
`;

export const SChips = styled.div`
  display: flex;
  gap: 6px;
  margin-top: 8px;
  flex-wrap: wrap;
`;

export const SChip = styled.button<{ active: boolean }>`
  padding: 5px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  background: ${({ active, theme }) =>
    active ? Colors.PrimaryColor : theme.input.backgroundColor};
  color: ${({ active, theme }) => (active ? Colors.White : theme.color)};
  border: 1px solid
    ${({ active, theme }) =>
      active ? Colors.PrimaryColor : theme.input.borderColor};
  &:hover {
    border-color: ${Colors.PrimaryColor};
    color: ${({ active }) => (active ? Colors.White : Colors.SecondaryColor)};
  }
`;

export const SMultiDay = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 8px 14px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
  color: ${Colors.WarningColor};
  background: ${Colors.WarningColorOpacity20};
  border: 1px solid ${Colors.WarningColorOpacity30};
`;
